"use client";
import { jsx } from "react/jsx-runtime";
import { DropdownCheckboxItem } from "../../primitive-dropdown/dropdown-checkbox-item.js";
import { GenericDropdown } from "./generic-dropdown.js";
function CheckboxesDropdown({ options: checkboxes, multiline, ...props }) {
    const options = checkboxes.map((option)=>({
            value: option.value,
            label: option.label,
            element: (elementProps)=>/*#__PURE__*/ jsx(DropdownCheckboxItem, {
                    checkbox: option,
                    multiline: multiline,
                    ...elementProps
                })
        }));
    return /*#__PURE__*/ jsx(GenericDropdown, {
        ...props,
        multiline: multiline,
        options: options,
        multiselect: true,
        allowDeselect: true
    });
}
export { CheckboxesDropdown };
